import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { assetsSchemaSettingsEntryPoint } from '@jira/spa-apps__servicedesk-cmdb-object-schema-configuration/src/assetsSchemaSettingsEntryPoint.entrypoint.tsx';
import { serviceDeskAssetsImportTypeForgeDataResource } from '@jira/router-resources__assets-import-type-forge-data/src/serviceDeskAssetsImportTypeForgeDataResource.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { assetsSchemaConfigurationRoute } from '@jira/router-routes__assets-app-routes/src/assetsSchemaConfigurationRoute.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import type { Route } from '@atlassian/react-resource-router';

const assetsSchemaSettingsPageEntryPoint = createChromelessEntryPoint({
	main: assetsSchemaSettingsEntryPoint,
});

export const assetsSchemaConfigurationRouteEntry: Route = createEntry(
	assetsSchemaConfigurationRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: AssetsSpinner,
		entryPoint: () => assetsSchemaSettingsPageEntryPoint,
		pageId: () => 'spa-apps/servicedesk/insight/cmdb-object-schema-configuration',
		resources: [...getAssetsAppResources(), serviceDeskAssetsImportTypeForgeDataResource],
		forPaint: [LazyAssetsLayout],
		perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
		meta: {
			reporting: {
				id: APP_NAMES.INSIGHT_GLOBAL_CONFIGURATION,
				packageName: toPackageName(APP_NAMES.INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
				teamName: 'krispy-krew',
			},
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
